import { render, staticRenderFns } from "./MemberRoleSelection.vue?vue&type=template&id=0edcd3aa&scoped=true&"
import script from "./MemberRoleSelection.vue?vue&type=script&lang=js&"
export * from "./MemberRoleSelection.vue?vue&type=script&lang=js&"
import style0 from "./MemberRoleSelection.vue?vue&type=style&index=0&id=0edcd3aa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edcd3aa",
  null
  
)

export default component.exports